import React from 'react';
export function BodyAsking() {
  return <section className="py-8 md:py-16 bg-primary" data-id="element-30">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-31">
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-3 md:mb-5 leading-tight" data-id="element-32">
          YOUR BODY IS ASKING FOR HELP.
        </h2>
        <p className="text-xl md:text-2xl text-white/90 leading-relaxed" data-id="element-33">
          And so is your family's.
        </p>
        <p className="text-xl md:text-2xl text-white/90 leading-relaxed mt-2" data-id="element-34">
          But nobody taught you how to answer —{' '}
          <span className="text-solution font-semibold" data-id="element-35">without chemicals</span>
          .
        </p>
      </div>
    </section>;
}